import React, { useState } from 'react';
import {
  TextField,
  InputAdornment,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { SearchFieldProps } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      width: '100%',
      '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.background.paper,
      },
    },
  }),
);

export const SearchField: React.FC<SearchFieldProps> = ({
  placeholder = 'Search prompts or users',
  value = '',
  onChange,
  onSearch,
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange?.(newValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch?.(inputValue);
    }
  };

  return (
    <TextField
      className={classes.textField}
      variant="outlined"
      size="small"
      value={inputValue}
      onChange={handleChange}
      onKeyPress={handleKeyPress}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};
